import React from 'react';
import { Breadcrumb as FlowbiteBreadcrumb } from 'flowbite-react';
import { SmallText } from '../typography/Typography';
import './breadcrumb.css';

/**
 * Breadcrumb Component
 * 
 * @param {Object} props
 * @param {Array} props.items - Array of breadcrumb items with label, href, onClick properties
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.rest - Additional props passed to Flowbite Breadcrumb
 */
const Breadcrumb = ({
    items = [],
    className = '',
    ...rest
}) => {
    // If only one item, show it without breadcrumb styling but keep it clickable
    if (items.length === 1) {
        const item = items[0];
        return (
            <div className={`m-6 ${className}`}>
                <a
                    href={item.onClick ? undefined : item.href}
                    onClick={item.onClick}
                    style={{ cursor: item.onClick ? 'pointer' : 'default' }}
                >
                    <SmallText weight="bold">
                        {item.label}
                    </SmallText>
                </a>
            </div>
        );
    }

    return (
        <FlowbiteBreadcrumb
            aria-label="breadcrumb"
            className={`m-6 custom-breadcrumb ${className}`}
        >
            {items.map((item, index) => (
                <FlowbiteBreadcrumb.Item
                    key={index}
                    href={item.onClick ? undefined : item.href}
                    onClick={item.onClick}
                    style={{ cursor: item.onClick ? 'pointer' : 'default' }}
                >
                    <SmallText
                        weight={item.isActive ? 'bold' : 'medium'}
                    >
                        {item.label}
                    </SmallText>
                </FlowbiteBreadcrumb.Item>
            ))}
        </FlowbiteBreadcrumb>
    );
};

export default Breadcrumb;
